import {DragAndDrop, LabelHelper, ObjectSelect2} from 'components';
import {Modal, ModalButtons} from '../../modals';
import {observer} from 'mobx-react';
import {AssignmentRule} from 'stores/documents';
import {auth, t} from 'shared/core';
import {useState} from 'react';
import _ from 'lodash';

const LOCALIZATION = {
  addModel: 'company_settings.documents.+ Add assignee'
};

const AddAssigneeModal = observer(({onHide, modalOpen, ruleOptions, companyDocument}) => {
  const [selectedAssignmentRule, setSelectedAssignmentRule] = useState({});
  const [errors, setErrors] = useState({});

  const onSave = () => {
    if (_.isEmpty(selectedAssignmentRule)) {
      setErrors({assignee: t('company_settings.documents.Assignee is required')});
      return;
    }

    companyDocument.addRule(selectedAssignmentRule);
    setSelectedAssignmentRule({});
    onHide();
  }

  return (
    <Modal title='company_settings.documents.Add Assignee' size='md' isOpen={modalOpen} onHide={onHide}>
      <ObjectSelect2
        label='company_settings.documents.Assignee'
        items={ruleOptions}
        value={selectedAssignmentRule}
        onChange={(rule) => setSelectedAssignmentRule(rule)}
        searchable={true}
        errorMessage={errors.assignee}
        by='assignee'
      />
      <ModalButtons onSave={onSave} onCancel={onHide}/>
    </Modal >
  );
});

const DocumentAssignmentRules = observer(({companyDocument, ruleOptions}) => {
  if (!auth.featureEnabled(':multiple_signatures')) return null;
  if (companyDocument.documentType !== 'pdf_template') return null;

  const [addAssignmentRuleModalOpen, setAddAssignmentRuleModalOpen] = useState(false);

  return (
    <div>
      <LabelHelper label={t('company_settings.documents.Assignees')}/>
      <DragAndDrop
        readOnlyDisplay={'name'}
        readOnly
        models={[new AssignmentRule({assigneeType: 'employee'})]}
      />
      <DragAndDrop
        models={companyDocument.assignmentRules}
        onRemove={(rule) => companyDocument.removeRule(rule)}
        display='name'
        onAdd={() => setAddAssignmentRuleModalOpen(true)}
        localization={LOCALIZATION}
      />
      <AddAssigneeModal
        onHide={() => setAddAssignmentRuleModalOpen(false)}
        modalOpen={addAssignmentRuleModalOpen}
        ruleOptions={ruleOptions}
        companyDocument={companyDocument}
      />
    </div>
  );

});

export default DocumentAssignmentRules;
